import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=86ee3c20&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.scss?vue&type=style&index=0&id=86ee3c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ee3c20",
  null
  
)

export default component.exports